module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/png@2x/chart_treemap@2x-7ef0c1.png";